<section [class.overflow-hidden]="overflowHidden">

  <ng-content select="mojo-collection-header"></ng-content>
  <ng-content select="mojo-collection-form"></ng-content>
  <ng-content></ng-content>
  <ng-content select="mojo-collection-footer"></ng-content>
</section>
